module.exports = __webpack_public_path__ + "img/_logo-zc-edasneo.217f3d8b.webp";